import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { SignUpContentServiceService } from "src/app/modules/registration/services/sign-up-content-service.service";
import { ContentService } from 'src/app/modules/cam/services/content.service';

@Component({
  selector: 'app-stop-onboarding',
  templateUrl: './stop-onboarding.component.html',
  styleUrls: ['./stop-onboarding.component.scss'],
  imports: [MatButton, RouterLink, MatIcon]
})
export class StopOnboardingComponent implements OnInit {
    registerDataContent: any;
    manageTravelerDataContent: any;
  @Input() heading: string = 'Title';
  @Input() content: string = 'no data available';
  @Input() content1: string = 'Try searching again';
  @Input() navigateTo: string = ''; // Default route
  @Input() IsShow: boolean = false;
  @Input() IsShowEmail: boolean = false;
  @Input() email: string = ''
  @Output() myEvent = new EventEmitter<string>();

  fetchMatchedEmail: string = ''

  emitEvent() {
    this.myEvent.emit(this.navigateTo);
  }

  AddNow() {
    this.emitEvent();
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.fetchMatchedEmail = this.email
      this.signUpContentService.content$.subscribe((res: any) => { this.registerDataContent = res; });
      this.manageTravelerContentService.content$.subscribe((res: any) => { this.manageTravelerDataContent = res; });
  }

    constructor(
        private readonly signUpContentService: SignUpContentServiceService,
        private readonly manageTravelerContentService: ContentService
    ) {}

    get alreadyRegisteredMessage() {
        return this.registerDataContent?.toastMessageList?.find((t: any) => t.messageID === 'b2b.register.alreadyregistered');
    }

    get splitDescription() {
        const message = this.alreadyRegisteredMessage?.description || 'Another account already exists with this email. Please contact your admin at {email} to receive a new invite to complete your profile on Saudia Business.';
        return message.split('{email}');
    }
}
